
import { Tab, Tabs } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { isUndefined } from 'util';
import { TabsLocalState } from '../../../Interfaces/Interfaces';

const MissionTabs = () => {
	const location = useLocation();
	const locationPathname = location.pathname.split('/')[3].toLowerCase();
	const locationState = location.state as TabsLocalState;
	const history = useHistory();

	const [state, setState] = useState<string>("Summary")

	useEffect(() => {
		switch (locationPathname) {
			case 'summary':
				setState("Summary");
				break;
			case 'events':
				setState("Events");
				break;
			case 'pilots':
				setState("Pilots");
				break;
		}
	}, [locationPathname])

	const goBackHandler = (evt:object, value: number|string) => {
		if (typeof value === 'number') {
			if (!isUndefined(locationState) && locationState[0] === 'campaign') {
				return history.push(`/Campaign/${locationState[1]}`);
			}
			history.push('/Missions');
		} else {
			history.push(value, locationState);
		}
	}


	return (
		<Tabs
			onChange={goBackHandler}
			aria-label="mission tabs"
			variant="scrollable"
			scrollButtons="on"
			value={state}
			//centered
			style={{ marginTop: 30, marginBottom: 30 }}
		>
			<Tab label="Go Back" value={0}/>
			<Tab label="Summary" value="Summary"/>
			<Tab label="Events" value="Events"/>
			<Tab label="Pilots" value="Pilots"/>
		</Tabs>
	)
}
export default MissionTabs ;
